/** A failed network refresh must not leave the initial session screen spinning forever. */
export function checkSessionWithDeadline<T>(read: () => Promise<T>, timeoutMs = 8_000): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Session check timed out')), timeoutMs);
    Promise.resolve()
      .then(read)
      .then(resolve, reject)
      .finally(() => clearTimeout(timer));
  });
}
